import { Action, createReducer, on } from '@ngrx/store';
import * as SearchActions from '@planone/bau365/data-access-search';
import * as WatchlistActions from '@planone/bau365/data-access-user';

import * as ExportActions from './export.actions';
import { ExportMetadata } from './export.models';

export const EXPORT_FEATURE_KEY = 'export';

export interface ExportState {
  generated: boolean;
  failed: boolean;
  identified: boolean;
  identification_failed: boolean;
  documentId?: string;
  metadata?: ExportMetadata;
}

export interface ExportPartialState {
  readonly [EXPORT_FEATURE_KEY]: ExportState;
}

export const initialExportState: ExportState = {
  generated: false,
  failed: false,
  identified: false,
  identification_failed: false,
  documentId: undefined,
};

const reducer = createReducer(
  initialExportState,
  on(WatchlistActions.generateWatchlistDocument, SearchActions.generateSearchDocument, (state) => ({
    ...state,
    generated: false,
    failed: false,
    documentId: undefined,
  })),
  on(
    WatchlistActions.generateWatchlistDocumentSuccess,
    SearchActions.generateSearchDocumentSuccess,
    (state, { documentId }) => ({
      ...state,
      generated: true,
      failed: false,
      documentId: documentId,
    })
  ),
  on(WatchlistActions.generateWatchlistDocumentFailure, SearchActions.generateSearchDocumentFailure, (state) => ({
    ...state,
    generated: false,
    failed: true,
    documentId: undefined,
  })),
  on(ExportActions.identifyMeta, (state: ExportState, { documentId }) => ({
    ...state,
    documentId: documentId,
    identified: false,
    identification_failed: false,
    metadata: undefined,
  })),
  on(ExportActions.metaIdentificationSucceeded, (state: ExportState, metadata: ExportMetadata) => ({
    ...state,
    identified: true,
    identification_failed: false,
    metadata: metadata,
  })),
  on(ExportActions.metaIdentificationFailed, (state: ExportState) => ({
    ...state,
    identified: true,
    identification_failed: true,
    metadata: undefined,
  }))
);

export function exportReducer(state: ExportState | undefined, action: Action) {
  return reducer(state, action);
}
